<template>
    <div>
        <no-data-dialog v-if="notifyDialog" @input="notifyDialog = false" />
        <v-form>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ isDownload ? "Download Category" : "Add Item" }}</span>
                </v-card-title>

                <v-card-text>
                    <v-row class="ml-1">
                        {{ isDownload ? "Choose a category to download" : "Choose an item to add" }}
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <template v-for="(card, i) in cards">
                                <v-btn v-if="!card.isMainCard && (hasClaim(card.apiMethod, true) || isDownload)" class="add-button-margin mr-1 mb-2" rounded :color="cardColorLookup[i]" @click="categoryChosen(card)" :key="i">{{card.title.replace(/([A-Z])/g, ' $1')}}</v-btn>
                            </template>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="quaternary" text @click="$emit('cancel')">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
    import enumService from '../services/enumService';
    import cardColorEnum from '../enums/cardColor';

    export default {
        props: [
            'cards',
            'isDownload'
        ],
        components: {
            noDataDialog: () => import('../export/NoDataDialog'),
        },
        data() {
            return {
                cardColorLookup: enumService.reverseEnum(cardColorEnum),
                notifyDialog: false
            }
        },
        methods: {
            categoryChosen(value) {
                if (value.items.length === 0 && this.isDownload) {
                    this.notifyDialog = true;
                    return;
                }
                this.$emit('categoryChosen', value)
            }
        },
    };
</script>
